// import React, { useState } from "react";
// import { Helmet } from "react-helmet"; // Helmet import

import RandingStyle6NewForm from "../../randing/RandingStyle6NewForm";
import RandingStyle6 from "../../randing/RandingStyle6";

function Randing027({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle6
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/027/01_241212_01.jpg`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/027/01_241212_02.gif`}
      img3Path={`${process.env.REACT_APP_CDN_BASE}/images/027/01_241212_04.jpg`}
      formFieldColor="white"
      img4Path={`${process.env.REACT_APP_CDN_BASE}/images/027/01_241212_03.jpg`} // 스텝 변경되는 이미지
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/027/postBTN.png`}
      companyName="본원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/ggul.jpg`}
      // addClass="mediaQuery027"
    />
  );
}

export default Randing027;
